module.exports = __webpack_public_path__ + "img/02.64f1fa1f.jpg";